module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<dl class=\"inline-definition-list\"> <dt>URL</dt> <dd>")
    ; __append(escapeFn( locals.url ))
    ; __append("</dd> <br> <dt>ID</dt> <dd>")
    ; __append(escapeFn( locals.id ))
    ; __append("</dd> ")
    ;  if(locals.disabled_at) { 
    ; __append(" <dt>Disabled</dt> <dd>on ")
    ; __append(escapeFn( locals.disabled_at ))
    ; __append("</dd> ")
    ;  } 
    ; __append(" </dl> ")
    ;  if(locals.disabled_at){ var cssClass="col-sm-6" } else { var cssClass="col-sm-12" }
    ; __append(" <div class=\"row\"> ")
    ;  if(locals.disabled_at) { 
    ; __append(" <div class=\"col-sm-6\"> <a href=\"#\" class=\"enable btn btn-success btn-xs btn-block\">Enable</a> </div> ")
    ;  } 
    ; __append(" <div class=\"")
    ; __append(escapeFn( cssClass ))
    ; __append("\"> <a href=\"#\" class=\"delete btn btn-red btn-xs btn-block\">Delete</a> </div> </div> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./templates/webhook_list_item.ejs
// module id = 886
// module chunks = 1